import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Typography from '../Typography';

const Container = styled.div`
  background-color: #f0f0f0;
`;

const TabPanel = styled.div`
  background-color: #ffffff;
  height: 61px;
`;

const TabItem = styled.button((props) => ({
  height: '24px',
  color: props.active ? '#169ab7' : '#808080',
  fontSize: '15px',
  letterSpacing: 0,
  lineHeight: '18px',
  textAlign: 'center',
  background: 'transparent',
  border: 'none',
  outline: 'none',
  padding: '29px 20px',
  cursor: 'pointer',
  transition: 'all ease-in-out 0.2s',
  borderBottom: props.active ? '3px solid #169ab7' : '3px solid transparent',
  position: 'relative',
  bottom: '15px',
}));

const HeaderTabItem = styled(Typography.Heading1)`
  height: 33px;
  font-size: 28px;
  letter-spacing: 0;
  line-height: 33px;
  color: #124754;
  position: relative;
  bottom: 15px;
  margin: 0;
  display: inline-block;
`;

export default class UnderlinedTabs extends React.Component {
  constructor(props) {
    super(props);
    const selectedIndex = props.children.length ? props.children.findIndex((k) => k.props.active) : -1;

    this.state = {
      activeTab: selectedIndex === -1 ? 0 : selectedIndex,
    };
  }

  changeTab = (index, tabProp) => {
    if (tabProp.onClick) {
      tabProp.onClick();
    }
    this.setState({ activeTab: index });
  };

  render() {
    let content;
    let tabProps = [];
    return (
      <Container>
        {React.Children.map(this.props.children, (child, index) => {
          tabProps.push(child.props);
          if (index === this.state.activeTab) content = child.props.children;
        })}

        <TabButtons activeTab={this.state.activeTab} changeTab={this.changeTab} tabProps={tabProps} />
        <div>{content}</div>
      </Container>
    );
  }
}

const TabButtons = ({ changeTab, activeTab, tabProps }) => {
  const selectedIndex = tabProps.findIndex((tab) => tab.active);
  return (
    <TabPanel>
      {tabProps.map((tabProp, index) => {
        if (tabProp.header) {
          return (
            <HeaderTabItem
              key={index}
              onClick={() => {
                return false;
              }}
            >
              {tabProp.label}
            </HeaderTabItem>
          );
        } else if (tabProp.disabled) {
          return (
            <TabItem
              key={index}
              onClick={() => {
                return false;
              }}
            >
              {tabProp.label}
            </TabItem>
          );
        } else if (index === activeTab) {
          if (tabProp.updateUrl) {
            window.history.pushState({}, null, tabProp.updateUrl);
          }
          return (
            <TabItem key={index} onClick={() => changeTab(index, tabProp)} active>
              {tabProp.label}
            </TabItem>
          );
        } else {
          return (
            <TabItem key={index} onClick={() => changeTab(index, tabProp)}>
              {tabProp.label}
            </TabItem>
          );
        }
      })}
    </TabPanel>
  );
};

export const UnderlinedTab = (props) => {
  return <React.Fragment>{props.children}</React.Fragment>;
};

UnderlinedTab.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  header: PropTypes.bool,
  disabled: PropTypes.bool,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  updateUrl: PropTypes.string,
};
